import { render, staticRenderFns } from "./RegionManagement.vue?vue&type=template&id=f00e6abe"
import script from "./RegionManagement.vue?vue&type=script&lang=ts"
export * from "./RegionManagement.vue?vue&type=script&lang=ts"
import style0 from "./RegionManagement.vue?vue&type=style&index=0&id=f00e6abe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports